import styled from 'styled-components';

export const Container = styled.div`
  background: #d22011;

  p {
    color: #000;
  }
`;
